module.exports = __webpack_public_path__ + "img/selected3-min.ed0865b0.png";